<template>
  <b-card>
    <b-form-select v-model="sortKey" :options="sortOption" class="sort-select"/>
    <b-nav tabs>
      <b-nav-item v-for="category of categories"
                  :key = "category.Id"
                  :active="category.Id === currentCategory"
                  @click = "changeCategory(category.Id)">
        {{category.CategoryName}}
      </b-nav-item>
    </b-nav>
    <m-loader :show="items.length === 0 " size="box"/>
    <div v-for="item of items" :key="item.ID" class="item-row">
      <div class="item-img">
        <b-img :src="$store.state.config.rootDomain + item.GiftImage" height="160" left style="margin-right: 16px"/>
        <div>
          <p class="item-title">{{item.GiftName}}</p>
          <p v-show="item.GiftName != item.GiftDesc">{{item.GiftDesc}}</p>
          <p class="item-point"><span class="item-point-desc">Points: </span>{{item.GiftPoint | numberFormat('', 0)}}</p>
        </div>
      </div>
      <div class="add-btn">
        <b-btn  @click="addCart(item)" v-show="item.quantity === 0 ">
          Add to Cart
        </b-btn>
        <div v-show="item.quantity > 0">
          <b-btn @click="addCart(item, -1)"
                 class="item-btn"> - </b-btn>
          <b-input type="number"
                    @input.native="updateCart(item, $event)"
                   :value="item.quantity"
                   class="item-input"></b-input>
          <b-btn @click="addCart(item)"
                 class="item-btn"> + </b-btn>
        </div>
      </div>
    </div>
  </b-card>
</template>

<script>
  export default {
    components: {
    },
    data () {
      return {
        sortKey: 'normal',  // 'normal', 'toMax', 'toMin'
        sortOldKey: 'noOldKey',
        sortOption: [
          {value: 'normal', text: 'Normal'},
          {value: 'toMax', text: 'Point low to high'},
          {value: 'toMin', text: 'Point high to low'}
        ]
      }
    },
    computed: {
      availablePoint () {
        return this.$store.state.reward.point.AvailablePoints
      },
      carts () {
        return this.$store.state.reward.carts
      },
      items () {
        let items = this.$store.state.reward.items[this.currentCategory]
        if (items === undefined || items.length === 0) {
          this.$store.dispatch('reward/getItem', this.currentCategory)
          return []
        }

        this.sortOldKey = this.sortKey
        items = items.sort((a, b) => {
          if (this.sortKey === 'normal') {
            return a.Id - b.Id
          }

          if (this.sortKey === 'toMax') {
            return a.GiftPoint - b.GiftPoint
          }

          if (this.sortKey === 'toMin') {
            return b.GiftPoint - a.GiftPoint
          }
        })

        for (let item of items) {
          item.quantity = 0
          for (let cart of this.carts) {
            if (item.Id === cart.GiftId) {
              item.quantity = cart.DesiredQuantity
            }
          }
        }
        return items
      },
      categories () {
        return this.$store.state.reward.categories
      },
      currentCategory () {
        return this.$store.state.reward.currentCategory
      }
    },
    methods: {
      addCart (item, qunatity) {
        item.quantity = qunatity || 1
        this.$store.commit('reward/updateCart', item)
      },
      updateCart (item, e) {
        let quantity = parseInt(e.target.value)
        if (isNaN(quantity)) {
          return false
        }
        item.quantity = quantity
        item.isUpdated = true
        this.$store.commit('reward/updateCart', item)
      },
      changeCategory (id) {
        this.$store.commit('reward/saveKey', ['currentCategory', id])
      }
    }
  }
</script>
<style scoped lang="scss">
  .item-row {
    border-bottom: 1px solid $color-border;
    margin-bottom: 16px;
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
  }
  .item-img {
    display: flex;
  }
  .item-title {
    font-size: 16px;
    padding-top: 16px;
    font-weight: bold;
    margin-bottom: 0;
  }
  .item-point {
    font-size: 16px;
    color: $color-primary;
    font-weight: bold;
  }
  .item-point-desc {
    font-weight: normal;
    font-size: 13px;
    color: $color-text-grey;
  }
  .add-btn {
    margin-top: 32px;
  }
  .item-btn {
    display: inline-block;
    width: 32px;
    padding: 5px;
  }
  .item-input {
    display: inline-block;
    width: 72px;
  }

  .nav-tabs .nav-link, .nav-link.active{
    min-width: 100px;
    text-align: center;
  }

  .sort-select {
    width: 200px;
    position: absolute;
    right: 16px;
    top: 18px;
  }
</style>



// WEBPACK FOOTER //
// src/components/reward/MRewardItem.vue